import type { default as React } from "react";

import { cn } from "@trip/utils";

export type InputProps = React.InputHTMLAttributes<HTMLInputElement>;

export const Input = ({
  className,
  type,
  ref,
  ...props
}: InputProps & {
  ref?: React.Ref<HTMLInputElement>;
}) => {
  return (
    <input
      className={cn(
        "shadow-field hover:shadow-field-hover flex h-10 w-full rounded-lg bg-white px-3 py-2 text-sm",
        "focus-visible:outline-prune-500 focus-visible:outline-2",
        "disabled:cursor-not-allowed disabled:opacity-50",
        "placeholder:text-muted/80 read-only:text-muted/80 read-only:bg-neutral-200",
        "file:border-0 file:bg-transparent file:text-sm file:font-medium",
        // Invalid state
        "data-invalid:shadow-[0_0_1px_0_oklch(var(--japan))] focus-visible:data-invalid:outline-japan",
        className,
      )}
      ref={ref}
      type={type}
      {...props}
    />
  );
};
Input.displayName = "Input";
